import { Check, Moon, Palette, Sun } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../lib/theme";

const Swatch = ({ sw }) => (
  <span className="flex overflow-hidden rounded-full border border-fg/20" aria-hidden="true">
    {sw.map((c) => <span key={c} className="h-4 w-2.5" style={{ background: c }} />)}
  </span>
);

export function ModeToggle({ className = "" }) {
  const { mode, toggleMode } = useTheme();
  const { lang } = useI18n();
  const dark = mode === "dark";
  const label = dark ? (lang === "ar" ? "الوضع الفاتح" : "Switch to light mode") : (lang === "ar" ? "الوضع الداكن" : "Switch to dark mode");
  return (
    <button type="button" data-testid="mode-toggle" data-mode={mode} onClick={toggleMode} aria-label={label} title={label}
      className={`rounded-full p-2 text-fg/80 transition-colors hover:bg-cta/10 hover:text-cta ${className}`}>
      {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
}

export function ThemePicker() {
  const { theme, themes, setTheme } = useTheme();
  const { lang, isRtl } = useI18n();
  if (themes.length < 2) return null;
  return (
    <DropdownMenu dir={isRtl ? "rtl" : "ltr"}>
      <DropdownMenuTrigger data-testid="theme-picker" aria-label={lang === "ar" ? "اختيار المظهر" : "Choose colour theme"} className="rounded-full p-2 text-fg/80 transition-colors hover:bg-cta/10 hover:text-cta">
        <Palette className="h-5 w-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 border-cta/20 bg-surface text-fg">
        {themes.map((t) => (
          <DropdownMenuItem key={t.key} data-testid={`theme-option-${t.key}`} onSelect={() => setTheme(t.key)} className="flex cursor-pointer items-center gap-3 py-2.5 focus:bg-cta/10 focus:text-fg">
            <Swatch sw={t.sw} /><span className="flex-1 text-sm">{lang === "ar" ? t.ar : t.en}</span>{theme === t.key && <Check className="h-4 w-4 text-cta" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function MobileThemeControls() {
  const { theme, themes, setTheme } = useTheme();
  const { lang } = useI18n();
  return (
    <div className="mt-6 border-t border-fg/10 pt-5" data-testid="mobile-theme-controls">
      <div className="mb-3 flex items-center justify-between">
        <p className="eyebrow">{lang === "ar" ? "المظهر" : "Appearance"}</p>
        <ModeToggle />
      </div>
      {themes.length > 1 && (
        <div className="grid grid-cols-2 gap-2">
          {themes.map((t) => (
            <button key={t.key} type="button" data-testid={`mobile-theme-option-${t.key}`} onClick={() => setTheme(t.key)}
              className={`flex items-center gap-2 rounded-sm border px-3 py-2 text-xs ${theme === t.key ? "border-cta bg-cta/10 text-cta" : "border-fg/15 text-fg/80"}`}>
              <Swatch sw={t.sw} />{lang === "ar" ? t.ar : t.en}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
